import { supabase } from '../lib/supabaseClient';
import { getUserProfile } from './dbService';

// Registrar usuario
export const signUp = async ({ email, password, fullName, avatarUrl, language }) => {
    try {
        const { data, error } = await supabase.auth.signUp({
            email,
            password,
            options: {
                data: { // Esto se guarda en auth.users.raw_user_meta_data
                    full_name: fullName,
                    avatar_url: avatarUrl || null, // string
                    language: language || null // string
                }
            }
        });

        if (error) throw error;

        // YA NO SE LLAMA A createUserProfile aquí. EL TRIGGER LO HARÁ.
        console.log("User signed up (pending email confirmation if enabled). User from signUp:", data.user);
        // Devolver el usuario y la sesión es útil para la UI, para indicar que el registro inicial fue bien
        // y que ahora deben confirmar su correo.
        return { user: data.user, session: data.session };
    } catch (error) {
        console.error('❌ Error en signUp:', error.message);
        throw error;
    }
};

// Para signInWithGoogle, si tienes un trigger, tampoco necesitas llamar a createUserProfile explícitamente.
export const signInWithGoogle = async (credentialResponse) => {
    try {
        if (!credentialResponse || !credentialResponse.credential) {
            throw new Error("Invalid Google credential response");
        }
        const { data, error } = await supabase.auth.signInWithIdToken({
            provider: 'google',
            token: credentialResponse.credential,
        });

        if (error) throw error;

        // Si el trigger on_auth_user_created está activo, creará el perfil
        // para un nuevo usuario de Google. Si el usuario ya existía, ya debería tener un perfil.
        // Puedes dejar la verificación con getUserProfile como una salvaguarda o para obtener el perfil.
        if (data.user) {
            let profile = await getUserProfile(data.user.id);
            if (!profile) {
                console.warn(`Profile not found for Google user ${data.user.id} after sign-in. Trigger should have handled this if new user.`);
                // Podrías decidir si reintentar crear el perfil aquí es necesario o si confías en el trigger.
                // Por ahora, asumimos que el trigger funcionará.
            }
            // Asegúrate de que la data de Google (full_name, avatar_url) se esté
            // guardando en user_metadata de auth.users para que el trigger la use.
            // Supabase generalmente hace esto por defecto para Google.
        }
        return { user: data.user, session: data.session };
    } catch (error) {
        console.error('❌ Error en login con Google (token):', error.message);
        throw error;
    }
};

// Iniciar sesión
export const signIn = async ({ email, password }) => {
    try {
        const { data, error } = await supabase.auth.signInWithPassword({ email, password });
        if (error) throw error;

        const profile = await getUserProfile(data.user.id);
        return { user: data.user, profile, session: data.session };
    } catch (error) {
        console.error('❌ Error en signIn:', error.message);
        throw error;
    }
};

export const signOut = async () => {
    try {
        const { error } = await supabase.auth.signOut();
        if (error) throw error;
        return true;
    } catch (error) {
        console.error('❌ Error en signOut:', error.message);
        throw error;
    }
};

export const getCurrentUser = async () => {
    try {

        const { data, error } = await supabase.auth.getUser();
        if (error) throw error;
        return data.user;
    } catch (error) {
        console.error('❌ Error al obtener usuario actual:', error.message);
        return null;
    }
};

export const resetPassword = async (email) => {
    try {
        // Construye la URL base. Asegúrate de que window.location.origin
        // sea el correcto para el entorno (desarrollo, producción).
        const redirectURL = `${window.location.origin}/reset-password`;
        console.log(`Requesting password reset, redirectTo: ${redirectURL}`); // Buen log para depurar

        const { error } = await supabase.auth.resetPasswordForEmail(email, {
            redirectTo: redirectURL
        });

        if (error) {
            console.error('Supabase error on resetPasswordForEmail:', error);
            throw error;
        }
        return true;
    } catch (error) {
        // El console.error ya se hizo arriba si es un error de Supabase
        if (!error.message.includes('Supabase error')) { // Evitar doble log
            console.error('❌ Error al solicitar reseteo de contraseña (catch general):', error.message);
        }
        throw error; // Es mejor relanzar el error para que el componente que llama (LoginPage) lo maneje
    }
};

// Actualizar contraseña del usuario autenticado
export const updateUserPasswordInAuth = async (newPassword) => {
    if (!newPassword || newPassword.trim() === '') {
        throw new Error("New password cannot be empty.");
    }
    try {
        const { error } = await supabase.auth.updateUser({
            password: newPassword,
        });
        if (error) throw error;
        return true; // O algún dato de éxito
    } catch (error) {
        console.error('❌ Error al actualizar contraseña en Supabase Auth:', error.message);
        throw error;
    }
};